import { invisibleStyle } from 'pages/Project/Common/Contract/OtherCreate/CreateOtherModal';

import type React from 'react';
import { useMemo } from 'react';

import type { ITabItem } from '../../Form';

interface IUseTabStyles {
    activeTab: ITabItem;
    tabItems: ITabItem[];
}

export const useTabStyles = (props: IUseTabStyles) => {
    const { activeTab, tabItems } = props;

    return useMemo(
        () =>
            tabItems.reduce(
                (acc, item) => {
                    acc[item.id] = activeTab.id !== item.id ? invisibleStyle : undefined;

                    return acc;
                },
                {} as Record<string, React.CSSProperties | undefined>,
            ),
        [activeTab.id, tabItems],
    );
};
